import * as React from 'react';

const BookmarkFillChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="bookmark-fill-chunky_svg__eds-icon--bookmark-fill-chunky_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bookmark-fill-chunky_svg__eds-icon--bookmark-fill-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 4v16l6-4 6 4V4z"
        />
    </svg>
);

BookmarkFillChunkySvg.displayName = 'BookmarkFillChunkySvg';
export default BookmarkFillChunkySvg;
